<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">

        <!-- Add notice form -->
        <div class="card p-4 lg:p-6">
            <h6 class="card-title">Add Product</h6>
            <form>
                <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">
                    <div class="col-span-full  lg:col-span-4 leading-none">
                        <label class="form-label">Type *</label>
                        <select class="form-input" v-model="product.prodcatid">
                            <option DISABLED value="0">SELECT CATEGORY</option>
                            <option v-for="(item, index)  in catList" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>

               
                        <div class="col-span-full  lg:col-span-4 leading-none">
                            <label for="tagname" class="form-label">Branch Name*</label>
                            <select v-model="product.branchid" class="form-input">
                            <option v-for="(item, index) in branchlist" :key="index" :value="item.id">
                                {{ item.name }}
                            </option>
                    </select>
                    </div>
             



                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Name *</label>
                         <select class="form-input w-full p-2 border border-gray-300 rounded" id="product_select2" ref="product_select2" v-model="product.name">
                                 <option v-for="(item, index) in productList" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                            
                        <!--<input type="text" id="prdname" v-model="product.name" placeholder="Type Here"-->
                        <!--    class="form-input" required autocomplete="off">-->
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Content *</label>
                        <input type="text" id="barcode" v-model="product.content" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Description *</label>
                        <input type="text" v-model="product.description" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">HSN *</label>
                        <input type="text" id="barcode" v-model="product.hsn" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">GST*</label>
                        <input type="text" id="barcode" v-model="product.gst" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg leading-none">
                     <hr>
                        <h1>Opening Stock******</h1>
                     </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Unit Size *</label>
                        <input type="text" v-model="product.unitsize" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Purchase Rate *</label>
                        <input type="number" id="barcode" v-model="product.purchaserate" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Batch No *</label>
                        <input type="text" id="barcode" v-model="product.batchno" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Manufacturing  Date *</label>
                        <input type="date" id="barcode" v-model="product.manufacturingdate" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Expiry  Date *</label>
                        <input type="date" id="barcode" v-model="product.expirydate" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

           

                    <!-- <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Opening Stock *</label>
                        <input type="number" id="barcode" v-model="product.openingstock" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div> -->

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Quantity *</label>
                        <input type="number" id="barcode" v-model="product.quantity" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full  lg:col-span-4 leading-none">
                        <label for="tagname" class="form-label">Unit*</label>
                       <select class="form-input" name="status" id="" v-model="product.unit">
                        <option value="">Choose Unit</option>
                        <option value="KG">KG</option>
                        <option value="LTR">LTR</option>
                        <!--<option value="Ltr">Ltr</option>-->
                        <!--<option value="ML">ML</option>-->
                       </select>
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Product Location *</label>
                        <input type="text" id="barcode" v-model="product.prdlocation" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

              

              



                    <!-- <div class="col-span-full lg:col-span-12 leading-none">
                        <label for="" class="form-label">Product Name *</label>
                        <input type="text" v-model="product.name" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-12 leading-none">
                        <label for="" class="form-label">Product Description *</label>
                        <input type="text" v-model="product.descr" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Unit *</label>
                        <input type="text" v-model="product.unit" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">GST rate *</label>
                        <input type="number" v-model="product.gst" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">MRP *</label>
                        <input type="number" v-model="product.mrp" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Purchase rate *</label>
                        <input type="number" v-model="product.prate" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">%</label>
                        <input type="number" v-model="percent" placeholder="Type Here" class="form-input" v-on:keyup.enter="cal_saleprice"
                            required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Sale rate *</label>
                        <input type="number" v-model="product.salerate" placeholder="Type Here" class="form-input"
                            required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">शिलाईसह रेट *</label>
                        <input type="number" v-model="product.stich_rate" placeholder="Type Here" class="form-input"
                            required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Set Rate *</label>
                        <input type="number" v-model="product.set_rate" placeholder="Type Here" class="form-input"
                            required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Set Quantity *</label>
                        <input type="number" v-model="product.set_qty" placeholder="Type Here" class="form-input"
                            required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-3 leading-none">
                        <label for="" class="form-label">Opening Stock *</label>
                        <input type="number" v-model="product.op_qty" placeholder="Type Here" class="form-input"
                            required autocomplete="off">
                    </div> -->
                </div>
            </form>
            <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6">
                Add Product
            </button>

        </div>
    </div>



</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
    name: 'AddProduct',
    components: {

    },
    mounted() {
        this.getBasics();
        $(".form-input").on('keyup')
    },
    data() {
        return {
            isAdd: 0,
            isEdit: 0,
            isDelete: 0,
            deleteId: 0,
            percent:40,
            catList: [],
            productList:[],
            branchlist:[],
            product: { 
                prodcatid:'',name: '', content:'',description:'',purchaserate:'',manufacturingdate:'',expirydate:'',batchno:'',quantity:'',hsn:'',gst:'',unit:'',branchid:'',unitsize:'',prdlocation:''},

                employees: { empname: '', emprole: '0', isMainAdmin: 0 },
        }
    },
    methods: {
        async getBasics() {
            var self = this;
            axios.post('getProdCats').then(function (response) {
                self.catList = response.data.cats;
                self.productList = response.data.productList;
                self.branchlist = response.data.branchList;
                self.employees = response.data.userDetails;
            }).then(()=>{ 
                
                 const selectElement = $("#product_select2");
                
                    // Initialize Select2
                    selectElement.select2({
                      placeholder: "Search or add an product",
                      allowClear: true,
                      language: {
                        noResults: () => "No results found. You can add a new option.",
                      },
                    }).on('change', function (event) {
                          const selectedValue = event.target.value;
                                                if (/^\d*$/.test(selectedValue)) {
                                                                      // If the value is numeric, find the product in the product list
                                                                      const selectedProduct = self.productList.find(
                                                                        (item) => item.id === selectedValue
                                                                      );
                                                                      if (selectedProduct) {
                                                                        self.product = {
                                                                          ...self.product, // Retain other existing product properties
                                                                          name: selectedProduct.name,
                                                                          content: selectedProduct.content,
                                                                          description: selectedProduct.description,
                                                                          hsn: selectedProduct.hsn,
                                                                          gst: selectedProduct.gst,
                                                                          prodcatid: selectedProduct.prodcatid,
                                                                        };
                                                                      } else {
                                                                        console.warn("Product not found in productList for ID:", selectedValue);
                                                                      }
                                                                    } else {
                                                                      // If the value is non-numeric, treat it as a new product name
                                                                      self.product = {
                                                                        ...self.product, // Retain other existing product properties
                                                                        name: selectedValue, 
                                                                          content: '',
                                                                          description: '',
                                                                          hsn:  '',
                                                                          gst:  '',
                                                                          prodcatid:0,
                                                                      };
                                                                    }
                                                  console.log(self.product.name);
                                        });
                                   
                                        
                                        selectElement.on("select2:open", () => {
                                          const searchBox = document.querySelector(".select2-search__field");
                                    
                                          if (searchBox) {
                                            searchBox.addEventListener("keyup", (event) => {
                                                if (event.key === "Enter") {
                                                    //alert('done');
                                                       const newOption = event.target.value;
                                                        if (newOption) {
                                                          // Add the new option dynamically
                                                          const newOptionElement = new Option(newOption, newOption, true, true);
                                                          selectElement.append(newOptionElement).trigger("change");
                                                          selectElement.select2("close");
                                                          self.product.name=newOption;
                                                        }
                                                        
                                                }
                                              const typedContent = event.target.value;
                                               
                                              // Customize "no results" message
                                              const noResultsMessage = document.querySelector(
                                                ".select2-results__message"
                                              );
                                              if (noResultsMessage) {
                                                noResultsMessage.innerHTML = `No results found for "<strong>${typedContent}</strong>". Press Enter to add this as a new option.`;
                                              }
                                            });
                                          }
                                        });
                                     
                                      
                                         });
                    
             
        },
        nextFocus(e) {
            try{
                const inputs = Array.from(e.target.form.querySelectorAll('input'));
                const index = inputs.indexOf(e.target);
    
                if (index < inputs.length) {
                    try {
                        inputs[index + 1].focus();
                        inputs[index + 1].select();
                    } catch (error) {
                        $("#saveBtn").focus();
                    }
                }
            }catch(ex){}
        },
        cal_saleprice(){
         
              this.product.salerate=(parseFloat(this.product.prate)+(parseFloat(this.product.prate) * ((parseFloat(this.percent)/100)))).toFixed(0);
           
        },
        save() {
            var self = this;
            if (self.product.name == '') 
                self.$swal("Product Name is Required");
            else if (self.product.branchid == '') 
                self.$swal("Branch Name is Required"); 
            else if (self.product.salerate == '') 
                self.$swal("Salerate is Required"); 
            else {
                self.$swal({
                    title: "Do You Want To Save?",
                    text: "Are you sure? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('addProduct', this.product)
                            .then(response => {
                                var msg = response.data.msg;
                                var isSuccess = response.data.status;
                                if (isSuccess) {
                                // Redirect to another page
                                window.location.href = 'http://157.173.221.162:8082/listproduct';
                            }
                                self.catList = response.data.cats;
                                self.employees = response.data.userDetails;
                                self.cat = { name: '', status: 'Active' };
                                if (isSuccess == 1) {
                                    self.product = { name: '', cat: '0', barcode: '', hsn: '', descr: '', gst: '5', unit: '', mrp: '0', prate: '0', salerate: '0', set_rate: '0', set_qty: '0', op_qty: '0' };
                                    $("#barcode").focus();
                                }


                                self.$swal(msg);

                            })
                            .catch(error => {
                                console.log('Error on Authentication: ' + error);
                            });
                    }
                });
            }

        },
    }
}
</script>
